import { PassDownloadTemplatesListContextProvider } from '../../store/client/PassDownloadTemplateListContext';
import PassDownloadTemplatesListContent from './PassDownloadTemplatesListContent';

const PassDownloadTemplatesPage = () => {
  return (
    <PassDownloadTemplatesListContextProvider>
      <PassDownloadTemplatesListContent />
    </PassDownloadTemplatesListContextProvider>
  );
};

export default PassDownloadTemplatesPage;
